import { action, createRequestTypes } from '../../base';

export const bulkPOActionTypes = {
  GET_BULK_PO: createRequestTypes('GET_BULK_PO'),
  CREATE_BULK_PO: createRequestTypes('CREATE_BULK_PO'),
  UPDATE_BULK_PO: createRequestTypes('UPDATE_BULK_PO'),
  UPDATE_BULK_PO_STATUS: createRequestTypes('UPDATE_BULK_PO_STATUS'),
  DELETE_BULK_PO: createRequestTypes('DELETE_BULK_PO'),
  GET_BULK_PO_BY_ID: createRequestTypes('GET_BULK_PO_BY_ID'),
};

/**
 * @param payload
 * @param getPoPendingApprovalLoading
 * @param tenantId
 * @param sendPOMailToVendorLoading
 * @param callback
 */
class BulkPOActions {
  /**
   * @param {*} orgId
   * @param {*} type
   * @param {*} tenantId
   * @param {*} page
   * @param {*} limit
   * @param searchKeyword
   * @return
   */
    getBulkPO = (orgId, bulkPOType, status, page, limit, searchKeyword) => action(bulkPOActionTypes.GET_BULK_PO.REQUEST, {
      orgId, bulkPOType, status, page, limit, searchKeyword,
    })

    /**
     *
     * @param getBulkPOLoading
     * @return {{type: *}}
     */
    getBulkPOLoading = (getBulkPOLoading) => action(bulkPOActionTypes.GET_BULK_PO.LOADING, {
      getBulkPOLoading,
    })

    /**
     * @param purchaseOrders
     * @param orgPos
     * @return {{type: *}}
     */
    getBulkPOSuccess = (bulkPurchaseOrders) => action(bulkPOActionTypes.GET_BULK_PO.SUCCESS, {
      bulkPurchaseOrders,
    })

    /**
     * @param payload
     * @param callback
     * @param withApproval
     * @return {{type: *}}
     */
    createBulkPO = (payload, callback, withApproval) => action(bulkPOActionTypes.CREATE_BULK_PO.REQUEST, {
      payload,
      callback,
      withApproval,
    })

    /**
     * @param createBulkPOLoading
     * @param addCustomBulkPOLoading
     * @return {{type: *}}
     */
     createBulkPOLoading = (createBulkPOLoading) => action(bulkPOActionTypes.CREATE_BULK_PO.LOADING, {
       createBulkPOLoading,
     })

    /**
     * @param {*} payload
     * @param {*} callback
     * @param withApproval
     * @param updateBulkPO
     * @return
     */
    updateBulkPO = (payload, callback, withApproval) => action(bulkPOActionTypes.UPDATE_BULK_PO.REQUEST, {
      payload,
      callback,
      withApproval,
    })

    /**
     *
     * @param updateBulkPOLoading
     * @return {{type: *}}
     */
    updateBulkPOLoading = (updateBulkPOLoading) => action(bulkPOActionTypes.UPDATE_BULK_PO.LOADING, {
      updateBulkPOLoading,
    })

    /**
   *
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updateBulkPOStatus = (payload, callback) => action(bulkPOActionTypes.UPDATE_BULK_PO_STATUS.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param updateBulkPOStatusLoading
   * @return {{type: *}}
   */
  updateBulkPOStatusLoading = (updateBulkPOStatusLoading) => action(bulkPOActionTypes.UPDATE_BULK_PO_STATUS.LOADING, {
    updateBulkPOStatusLoading,
  })

    /**
     * @param poId
     * @param tenantId
     * @param callback
     * @return {{type: *}}
     */
    getBulkPOById = (orgId, bulkPOType, bulkPOId, callback) => action(bulkPOActionTypes.GET_BULK_PO_BY_ID.REQUEST, {
      orgId,
      bulkPOType,
      bulkPOId,
      callback,
    })

    /**
     * @param getBulkPOByIdLoading
     * @return {{type: *}}
     */
     getBulkPOByIdLoading = (getBulkPOByIdLoading) => action(bulkPOActionTypes.GET_BULK_PO_BY_ID.LOADING, {
       getBulkPOByIdLoading,
     })

     /**
      * @param selectedBulkPO
      * @param selectedPo
      * @return {{type: *}}
      */
     getBulkPOByIdSuccess = (selectedBulkPO) => action(bulkPOActionTypes.GET_BULK_PO_BY_ID.SUCCESS, {
       selectedBulkPO,
     })

  /**
   *
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  deleteBulkPO = (payload, callback) => action(bulkPOActionTypes.DELETE_BULK_PO.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param deleteBulkPOLoading
   * @return {{type: *}}
   */
   deleteBulkPOLoading = (deleteBulkPOLoading) => action(bulkPOActionTypes.DELETE_BULK_PO.LOADING, {
     deleteBulkPOLoading,
   })
}

export default new BulkPOActions();
